import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <div className={`overline flex items-center gap-3 ${dark ? "text-accent-2" : "text-accent"}`}>
    <span className={`inline-block h-px w-8 ${dark ? "bg-[var(--secondary-2)]" : "bg-accent-c"}`} />
    {children}
  </div>
);
